import { Mitarbeiter_DeleteAbschnittMutation, Mitarbeiter_DeleteAbschnittMutationVariables, } from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { DELETE_ABSCHNITT } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteAbschnitt/mutation.ts';

export function useDeleteAbschnitt() {
  const [execute, result] = useMutation<
    Mitarbeiter_DeleteAbschnittMutation,
    Mitarbeiter_DeleteAbschnittMutationVariables
  >(DELETE_ABSCHNITT, {
    refetchQueries: ['mitarbeiter_rotationsplanById'],
    awaitRefetchQueries: true,
  });

  const deleteStation = useCallback(
    (variables: Mitarbeiter_DeleteAbschnittMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [deleteStation, result] as const;
}
